// Libraries
import * as React from "react"
import moment from "moment"

// Component
import Slider from "react-slick"
import { Link } from "gatsby"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowLeft, faArrowRight } from "@fortawesome/pro-solid-svg-icons"
import { GatsbyImage } from "gatsby-plugin-image"

class HomeSlider extends React.Component {
	render() {
		const { events } = this.props

		const settings = {
			dots: false,
			infinite: true,
			speed: 500,
			slidesToShow: 1,
			slidesToScroll: 1,
			centerMode: true,
			centerPadding: "10%",
			prevArrow: <FontAwesomeIcon icon={faArrowLeft} />,
			nextArrow: <FontAwesomeIcon icon={faArrowRight} />,
		}

		return (
			<div className="event-slider">
				<Slider {...settings}>
					{events.map(event => (
						<div className="event-slide">
							<Link to={`/events/${event.event.slug}`} className="link">
								{event.image_gatsby && (
									<GatsbyImage
										className="event-image"
										image={event.image_gatsby.childImageSharp.gatsbyImageData}
										alt={`${event.event?.artist?.name ?? event.event?.performer_name} - ${event.event.name}`}
									/>
								)}
								<div className="event-child">
									<div className="event-text-container">
										<h3>{event.event?.artist?.name ?? event.event?.performer_name}</h3>
										<h4>{event.event.name}</h4>
										<p>
											{event.event.venue.name}
											<br />
											{moment(event.event.starts).format("MMMM D, Y")}
										</p>
									</div>
								</div>
							</Link>
						</div>
					))}
				</Slider>
			</div>
		)
	}
}

export default HomeSlider
